import store, { RootState } from '@/redux/store';
import { ExternalIcon } from '@shopify/polaris-icons';

export const FINISHED_STEPS = ['Synced orders', 'Add prioritized carriers', 'Branded tracking page'] as const;

export const getExternalActions = (storefrontLink: string) => {
  const {
    auth: {
      data: { shop },
    },
  } = store.getState() as RootState;

  const handleRedirectToDeepLinking = () => {
    const appBlockId = process.env.REACT_APP_THEME_APP_EXTENSION_ID;

    window.open(`https://${shop}/admin/themes/current/editor?addAppBlockId=${appBlockId}/order-tracking&target=main`, '_blank');
  };

  return [
    {
      icon: ExternalIcon,
      text: 'View tracking page',
      url: storefrontLink,
      onClick: undefined,
    },
    {
      icon: ExternalIcon,
      text: 'Add order lookup widget',
      onClick: handleRedirectToDeepLinking,
      url: undefined,
    },
  ];
};
